import Header, { HeaderProps } from './Header';

export type { HeaderProps };
export default Header;
